if (!window.gemonierCartInitialized) {
  window.gemonierCartInitialized = true;
  const countdownKey = 'gemonier-cart-priority-deadline-v1';
  const countdownDuration = (34 * 60 + 52) * 1000;
  let countdownDeadline;
  customElements.define('gemonier-cart-countdown', class extends HTMLElement {
    connectedCallback() {
      if (!countdownDeadline) {
        try { countdownDeadline = Number(sessionStorage.getItem(countdownKey)); } catch (_) {}
        if (!Number.isFinite(countdownDeadline) || countdownDeadline <= 0) {
          countdownDeadline = Date.now() + countdownDuration;
          try { sessionStorage.setItem(countdownKey, String(countdownDeadline)); } catch (_) {}
        }
      }
      const update = () => {
        const remaining = Math.max(0, Math.ceil((countdownDeadline - Date.now()) / 1000));
        const time = this.querySelector('[data-gm-cart-countdown]');
        if (time) time.textContent = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
        this.hidden = remaining === 0;
        if (!remaining) clearInterval(this.countdownInterval);
      };
      clearInterval(this.countdownInterval);
      this.countdownInterval = setInterval(update, 1000);
      update();
    }
    disconnectedCallback() { clearInterval(this.countdownInterval); }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gm-cart-step]');
    if (!button || button.disabled) return;
    const controls = button.closest('line-item-quantity');
    const input = controls.querySelector('input[data-line-key]');
    const next = Math.max(1, Math.min(Number(input.value) + Number(button.dataset.gmCartStep), Number(input.max) || Infinity));
    if (next === Number(input.value)) return;
    input.value = String(next);
    controls.querySelectorAll('button').forEach(control => { control.disabled = true; });
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('gemonier-cart-upsell select');
    if (!select) return;
    const card = select.closest('gemonier-cart-upsell');
    const option = select.selectedOptions[0];
    card.querySelector('[data-gm-upsell-price]').textContent = option.dataset.price;
    const compare = card.querySelector('[data-gm-upsell-compare]');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    const image = card.querySelector('img');
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
    }
    card.querySelector('[role="alert"]').hidden = true;
  });
  document.addEventListener('cart:error', event => {
    const card = event.target.closest('gemonier-cart-upsell');
    if (!card) return;
    const error = card.querySelector('[role="alert"]');
    error.textContent = event.detail.error;
    error.hidden = false;
  });
}

if (!window.gemonierCartReturnInitialized) {
  window.gemonierCartReturnInitialized = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-gm-cart-return]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    try {
      const previous = new URL(document.referrer);
      if (previous.origin === location.origin && /\/(products|collections)(\/|$)/.test(previous.pathname)) {
        event.preventDefault();
        location.assign(previous.href);
      }
    } catch (_) {}
  });
}
